var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18H2M5 18H8H10M5 18V11M5 18H2M15 18H12H10M15 18V11M15 18H18M19 18H18M10 4L6.20098 7.03922C5.75994 7.39205 5.53943 7.56846 5.3807 7.78743C5.24008 7.98141 5.13546 8.19908 5.07183 8.43007C5 8.6908 5 8.9732 5 9.538V11M10 4L13.799 7.03922C14.2401 7.39205 14.4606 7.56846 14.6193 7.78743C14.7599 7.98141 14.8645 8.19908 14.9282 8.43007C15 8.6908 15 8.9732 15 9.538V11M10 4V2.6C10 2.09022 10 1.83533 10.1701 1.58232C10.2879 1.40706 10.6039 1.19803 10.8113 1.15817C11.1106 1.10063 11.261 1.16453 11.5616 1.29233C12.2559 1.58747 12.7154 2 14 2M15 11H16.4C16.9601 11 17.2401 11 17.454 11.109C17.6422 11.2049 17.7951 11.3578 17.891 11.546C18 11.7599 18 12.0399 18 12.6V18M10 18V14M5 11H3.6C3.03995 11 2.75992 11 2.54601 11.109C2.35785 11.2049 2.20487 11.3578 2.10899 11.546C2 11.7599 2 12.0399 2 12.6V18",
    stroke: "#C1C5D6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.4e242e17958ce38433159d1bb62d2de2.svg";
export { ForwardRef as ReactComponent };